import React, {PureComponent} from 'react';
import style from './IndexPersons.css';

const Person = ({person}) => {
  return <div className={style.person}>
    <h4>{person.name}</h4>
  </div>
}

export default class IndexPersons extends PureComponent {
  render() {
    return (
        <div className={style.container}>
          {/*<div className={style.label}>人物</div>*/}
          <Person person={{name: '张雪峰'}}/>
          <Person person={{name: '王涛'}}/>
          <Person person={{name: '留档'}}/>
        </div>
    )
  }
}
